const name = "MODALS";

export const SHOW_MODAL = `${name}/SHOW_MODAL`;
export const HIDE_MODAL = `${name}/HIDE_MODAL`;